import React from "react";
import { Constants } from "../../../../../constants/constants";
import { useUpsellWidgetModel } from "../../../hooks/useUpsellWidgetModelContext";

export const RememberMeCheckbox = ({ register, showRememberDeviceText }) => {
    const model = useUpsellWidgetModel();
    const cssClass = `font-17 mt-3 ${model.isCompetitionPage ? model.textPrimaryColor : "text-color-gray-16"}`;
    return <>
        <label className="mb-0 checkbox-container">
            <input type="checkbox"
                defaultChecked={true}
                {...register("RememberMe")}
            />
            <span className="checkmark" style={{ top: '3px' }}></span>
            {showRememberDeviceText ?
                <span className={cssClass}>{Constants.REMEMBER_DEVICE_TEXT}</span>
                :
                <span className={cssClass}>Remember me</span>
            }
        </label>
        <div className={cssClass}>{Constants.PUBLIC_COMPUTER_MESSAGE}</div>
    </>;
};